import { getStorage } from "@/utils/storage";

function useLogin() {
  const afterLoginList = [];
  const afterLoginoutList = [];

  function addLoginEvent(type = "login", keyHandle = {}) {
    let eventList;
    if (type === "login") {
      eventList = afterLoginList;
    } else {
      eventList = afterLoginoutList;
    }
    const { key, handler, cache } = keyHandle;
    if (eventList.some((item) => item.key === key)) return;
    eventList.push(keyHandle);
    // 如果登录了，直接执行
    if (getStorage("token")) {
      execuLoginHandler("login", key);
    }
  }

  function execuLoginHandler(type = "login", key = "") {
    let execuList;
    if (type === "login") {
      execuList = afterLoginList;
    } else {
      execuList = afterLoginoutList;
    }
    const cacheList = [];
    execuList.forEach((item) => {
      if (key === "") {
        if (item.handler) {
          item.handler();
        }
        if (item.cache) cacheList.push(item);
      } else if (item.key === key) {
        if (item.handler) {
          item.handler();
        }
        if (item.cache) cacheList.push(item);
      }
    });
    execuList.length = 0;
    execuList.push(...cacheList);
  }
  function removeLoginEvent(key = "") {
    const loginIndex = afterLoginList.findIndex((item) => item.key === key);
    if (loginIndex > -1) {
      afterLoginList.splice(loginIndex, 1);
    }
    const loginoutIndex = afterLoginoutList.findIndex(
      (item) => item.key === key
    );
    if (loginoutIndex > -1) {
      afterLoginoutList.splice(loginoutIndex, 1);
    }
  }
  return {
    addLoginEvent,
    afterLoginoutList,
    afterLoginList,
    removeLoginEvent,
    execuLoginHandler,
  };
}
const {
  addLoginEvent,
  afterLoginoutList,
  afterLoginList,
  removeLoginEvent,
  execuLoginHandler,
} = useLogin();

export {
  addLoginEvent,
  afterLoginoutList,
  afterLoginList,
  removeLoginEvent,
  execuLoginHandler,
};
